import React from 'react';
import { motion } from 'framer-motion';
import './Paiement.css';
import { LuTicket, LuBanknote, LuMapPin, LuGlobe, LuShieldCheck, LuLock } from 'react-icons/lu';

const METHODS = [
  {
    icon: <LuTicket strokeWidth="1.2px" />,
    stat: '100%',
    statLabel: 'Sans carte bancaire',
    title: 'Paysafecard',
    desc: "Le paiement par Paysafecard est un paiement sécurisé par code prépayé. Avec Paysafecard, vous pouvez régler votre livraison en toute sécurité sans utiliser de carte bancaire ni partager vos informations bancaires. Il vous suffit d'acheter un ticket Paysafecard contenant un code pour votre confirmation de livraison.",
    points: [
      { icon: <LuMapPin size={13} />, text: 'Dans les bureaux de tabac et points de vente agréés' },
      { icon: <LuGlobe size={13} />, text: 'En ligne sur les plateformes et revendeurs autorisés' },
    ],
    note: 'Simple, rapide et idéal pour effectuer des paiements en toute confidentialité.',
  },
  {
    icon: <LuBanknote strokeWidth="1.2px" />,
    stat: 'IBAN',
    title: 'Virement bancaire',
    desc: "Le paiement par virement bancaire vous permet de transférer directement le montant de votre commande depuis votre compte bancaire vers notre compte professionnel. Après validation de votre commande, nos coordonnées bancaires (RIB/IBAN) vous seront communiquées afin d'effectuer le virement. La commande sera confirmée dès réception du paiement sur notre compte.",
    points: [
      { icon: <LuShieldCheck size={13} />, text: 'Recommandé pour les transactions sécurisées' },
      { icon: <LuLock size={13} />, text: 'Idéal pour les montants importants' },
    ],
    note: 'Vos coordonnées bancaires sont transmises uniquement après validation de la commande.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function Paiement() {
  return (
    <section id="paiement" className="paiement" data-tracking-name="Paiement">
      {/* Fond décoratif identique à Atouts */}
      <div className="paiement-bg-shape" />

      <div className="paiement-container">

        {/* En-tête */}
        <motion.div
          className="paiement-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label">Paiement</span>
          <h2 className="section-title">
            Modes de paiement
          </h2>
          <p className="paiement-intro">
            Deux solutions sécurisées adaptées à tous les profils — choisissez celle qui
            correspond le mieux à vos besoins.
          </p>
        </motion.div>

        {/* Grille de cards — identique à Atouts */}
        <motion.div
          className="paiement-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
        >
          {METHODS.map((method) => (
            <motion.div
              key={method.title}
              className="paiement-card"
              variants={itemVariants}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
            >
              {/* Top : icône + stat */}
              <div className="paiement-card-top">
                <span className="paiement-icon">{method.icon}</span>
                <div className="paiement-stat-box">
                  <span className="paiement-stat-value">{method.stat}</span>
                  <span className="paiement-stat-label">{method.statLabel}</span>
                </div>
              </div>

              <h3 className="paiement-card-title">{method.title}</h3>
              <p className="paiement-card-desc">{method.desc}</p>

              {/* Points de disponibilité */}
              <ul className="paiement-points">
                {method.points.map((pt, i) => (
                  <li key={i} className="paiement-point">
                    <span className="paiement-point-check">✓</span>
                    {pt.text}
                  </li>
                ))}
              </ul>

              {/* Note encart */}
              <div className="paiement-card-note">
                {method.note}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}